export default class Utils {
	static  options () {
		return {
				places: [ 
					{id: 'minsk', name: 'Минск'},
					{id: 'remote', name: 'Удаленное место'} 
				],
				scheduleChange: [
					{ name: "Изменение", id: "change"},
					{ name: "Отмена", id: "cencel"},
					{ name: "Больничный", id: "ill"},
					{ name: "Прогул", id: "absenteeism"}
				],
				departments: [
					{ id: 'Inbound', name: 'Входящие'},
					{ id: 'Outstaffing', name: 'Аутстафинг'},
					{ id: 'Outbound', name: 'Исходящие'},
					{ id: 'Finance', name: 'Финансы'},
					{ id: 'Administaration', name: 'Администрация'}
				],
				scheduleType: [
					{name: "Дневная 1", id: "day1"},
					{name: "Дневная 2", id: "day2"},
					{name: "2/2", id: "shift"},
					{name: "Вечерняя", id: "evening"},
					{name: "Ночная", id: "nigth"}
				],
				reportsStatus: [
				    { id: 'Advance', name: 'Подготовлен' },
				    { id: 'Approved', name: 'Утвержден' },
				    { id: 'Accepted', name: 'Подписан' },
				    { id: 'Cenceled', name: 'Анулирован' }
				],
				operatorsTypes: [
					{ id: 'operator', name: 'Оператор' },
					{ id: 'leader', name: 'Супервизор' },
					{ id: 'staf', name: 'Администрация' },
					{ id: 'senior', name: 'Старший' },
					{ id: 'test', name: 'Обучение' }
				],
				contractTypes: [
					{ id:'Contract', name: 'Контракт' },
					{ id:'Contractor', name: 'Подряд' }
				],
				parttimeTypes: [
					{ id: 'Full', name: 'Полная' },
					{ id: 'Half', name: 'Половина' },
					{ id: 'Quarter', name: 'Четверть' }
				],
			}
	}

}